<template>
  <div>
    <div class="container">
      <div class="flex flex-wrap -mx-4">
        <div class="w-full md:w-5/6 lg:w-2/3 md:ml-[8.333333%] lg:ml-[16.666667%] px-4">
          <h2 class="text-center mb-7">
            Welche Zuzahlungen erwarten mich beim Zahnarzt?
          </h2>

          <ZZTable :value="value" />
        </div>
      </div>
    </div>

    <div class="text-center mb-14">
      <Teeth />
    </div>
  </div>
</template>

<script>
import ZZTable from '../zahnzusatz/Table.vue';
import Teeth from '../zahnzusatz/Teeth.vue';

export default {
  components: {
    ZZTable,
    Teeth,
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
};
</script>
